import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

// containers
import LoginForm from '../components/Auth/LoginForm';
import PublicLayout from '../layouts/PublicLayout';

// app routes
import appRoutes from '../routes/appRoutes';

import { login } from '../api/auth';
import * as storageApi from '../api/storage';

import { USER_TYPE } from '../utils/constants/common';
import { useAuth } from '../context/AuthContext';
import useToast from '../hooks/useToast';

const LoginPage = () => {
  const { showToast } = useToast();
  const { setIsAuthenticated, setUser } = useAuth();
  const [serverMsg, setServerMsg] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (formValues) => {
    try {
      const res = await login(formValues);
      const { token, user } = res.data;
      storageApi.set('token', token);
      storageApi.set('user', JSON.stringify(user));
      setIsAuthenticated(token);
      setUser(user);
      if (user.userType === USER_TYPE.SUPER_ADMIN) {
        navigate(
          user.forcePasswordChange
            ? `/superadmin/${appRoutes.updatePassword}`
            : `/superadmin/${appRoutes.keyPerformance}`
        );
      } else if (user.userType === USER_TYPE.DOCTOR) {
        navigate(
          user.forcePasswordChange
            ? `/${user.userType}/${appRoutes.updatePassword}`
            : `/${user.userType}/${appRoutes.practitionerConsents}`
        );
      } else {
        navigate(
          user.forcePasswordChange
            ? `/${user.userType}/${appRoutes.updatePassword}`
            : `/${user.userType}/${appRoutes.keyPerformance}`
        );
      }
      showToast('User logged in successfully', 'success');
    } catch (error) {
      setServerMsg('Incorrect Username / Password');
      setTimeout(() => {
        setServerMsg('');
      }, 5000);
    }
  };

  return (
    <PublicLayout>
      <Box width={1}>
        <Typography variant="h3" mb={1}>
          Login
        </Typography>
        <Typography paragraph>Please enter your email address and password to login</Typography>
      </Box>
      {serverMsg && (
        <Box mt={2} textAlign="center">
          <Typography className="error" mb={1}>
            {serverMsg}
          </Typography>
          {serverMsg && (
            <Typography className="error">
              Contact Support on 07 3555 5888
              <br />
              if you require assistance
            </Typography>
          )}
        </Box>
      )}
      <Box width={1}>
        <LoginForm onFormSubmit={handleLogin} />
      </Box>
    </PublicLayout>
  );
};

export default LoginPage;
